import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

/**
 * Code-split a named export: `const Desk = lazyNamed(() => import('./pages'), 'CirculationDeskPage');`
 * Shells wrap their <Outlet/> in <Suspense>, so a lazy page can be used directly as a route element.
 */
export function lazyNamed<M extends Record<string, unknown>, K extends keyof M & string>(loader: () => Promise<M>, name: K): LazyExoticComponent<M[K] extends ComponentType<infer P> ? ComponentType<P> : ComponentType> {
  return lazy(async () => {
    const mod = await loader();
    return { default: mod[name] as ComponentType };
  }) as LazyExoticComponent<M[K] extends ComponentType<infer P> ? ComponentType<P> : ComponentType>;
}
